import React from "react";
import { ITabsListProps } from "./TabsList.types";
import { Tab, TabProps, Tabs, TabsProps, styled } from "@mui/material";
import { a11yProps } from "./utils";
import { CSS_CONSTANTS } from "../../constants/cssConstants";

export const TabsList: React.FC<ITabsListProps> = (props) => {
  const { selectedTab, varaint, tabs, onChange } = props;

  return (
    <CustomTabs
      value={selectedTab}
      variant={varaint}
      scrollButtons="auto"
      allowScrollButtonsMobile
      sx={props.sx}
      onChange={onChange}
      TabIndicatorProps={{ hidden: true }}
    >
      {tabs.map((tab, index) => {
        if (tab.hidden) return null;
        return (
          <CustomTab
            key={index}
            icon={tab.icon}
            iconPosition={tab.iconPosition || "start"}
            label={tab.label}
            disabled={tab.disabled}
            hidden={tab.hidden}
            sx={tab.sx}
            {...a11yProps(tab.index !== undefined ? tab.index : index)}
          />
        );
      })}
    </CustomTabs>
  );
};

export const CustomTabs = styled((props: TabsProps) => <Tabs {...props} />)(
  ({ theme }) => ({
    backgroundColor: `${
      theme.palette.mode === "dark" ? "rgba(73,82,88,0.12)" : "#fff"
    }`,
    boxShadow: "rgba(90, 114, 123, 0.11) 0px 7px 30px 0px",
    padding: "2px",
    borderRadius: CSS_CONSTANTS.BORDER_RADIUS,
    border: `1px solid ${theme.palette.grey[300]}`,
    [theme.breakpoints.up("md")]: {
      padding: "2px",
      borderRadius: "10px",
      minHeight: "28px",
    },
    [theme.breakpoints.up("lg")]: {
      padding: "4px",
     borderRadius: CSS_CONSTANTS.BORDER_RADIUS,
      
    },
    [theme.breakpoints.up("xl")]: {
      padding: "8px",
     borderRadius: CSS_CONSTANTS.BORDER_RADIUS,
      minHeight: "40px",
    },
    "& .MuiTabs-flexContainer": {
      gap: "10px",
    },
    "& .Mui-selected": {
      background: theme.palette.primary.main,
      color: "#fff !important",
     borderRadius: CSS_CONSTANTS.BORDER_RADIUS,
      fontWeight: 800,
      [theme.breakpoints.up("md")]: {
        borderRadius: "10px",
      },
      [theme.breakpoints.up("lg")]: {
       borderRadius: CSS_CONSTANTS.BORDER_RADIUS,
        
      },
      [theme.breakpoints.up("xl")]: {
      borderRadius: CSS_CONSTANTS.BORDER_RADIUS,
      },
    },
  })
);

export const CustomTab = styled((props: TabProps) => <Tab {...props} />)(
  ({ theme }) => ({
    fontSize: "1rem",
    padding: "8px",
    [theme.breakpoints.up("md")]: {
      padding: "5px",
    },
    [theme.breakpoints.up("lg")]: {
      padding: "7px",
    },
    [theme.breakpoints.up("xl")]: {
      padding: "8px",
    },
  })
);
